import { leadershipArr } from "./leadership";
import { scienceArr } from "./science";
import { techArr } from "./tech";
import { marketingArr } from "./marketing";
import { boardArr } from "./board";
import { partnersObj } from "./partners";
import { advisorsObj } from "./advisors";

export const s3Bucket = `https://ctrees-website.s3.amazonaws.com/staff_photos/`;

export const leadershipImgs = {
    daniel: `${s3Bucket}dmelling.jpg`,
    phil: `${s3Bucket}pdecola.jpg`,
    naomi: `${s3Bucket}nprovost.jpg`,
    stephen: `${s3Bucket}shagen.JPG`,
    sassan: `${s3Bucket}ssaatchi.jpg`,
    rami: `${s3Bucket}rassad.JPG`,
    janet: `${s3Bucket}jsmith.jpeg`,
    chris: "https://ctrees-website.s3.us-west-2.amazonaws.com/news/cwoodall.jpeg",
    ray: `${s3Bucket}rsong.jpg`,
};

export const teamFunctions = {
    leadership: { display: "leadership", id: "leadership" },
    science: { display: "science", id: "science" },
    tech: { display: "technology", id: "tech" },
    market: { display: "engagement", id: "market" },
    op: { display: "operations", id: "op" },
};

export const altFunctions = {
    board: { display: "board of directors", id: "board" },
    partners: { display: "scientific partners", id: "partners" },
    advisors: { display: "advisors", id: "advisors" },
};

export const leadership = leadershipArr();
export const science = scienceArr();
export const tech = techArr();
export const market = marketingArr();
export const board = boardArr();
export const partners = partnersObj();
export const advisors = advisorsObj();

export const countries = {
    fr: "France",
    us: "USA",
    br: "Brazil",
    ne: "The Netherlands",
    it: "Italy",
    dn: "Denmark",
};

export const op = [
    {
        name: "Rami Assad",
        img: leadershipImgs.rami,
        title: "Head of Finance and Administration",
    },
    {
        name: "Vaiman Shum",
        img: `${s3Bucket}vshum.jpg`,
        title: "Senior Accountant",
    },
    {
        name: "Susana Tran",
        img: `${s3Bucket}stran.jpeg`,
        title: "Administrative Assistant",
    },
];


